import { combineReducers } from 'redux';
import userData from './userData';
import workspaceSettings from './workspaceSettings';
import workspaceUsers from './workspaceUsers';
import notification from './notification';
import allNotification from './allNotification';
import agreementflow from "./agreementflow";

const rootReducer = combineReducers({
  userData,
  workspaceSettings,
  workspaceUsers,
  allNotification,
  notification,
  agreementflow,
});

export default rootReducer;
